import React from "react";
import {useTranslation} from "react-i18next";

import MDLoadingButton from "../../../components/MDLoadingButton";

import MDBox from "materialDashboard/components/MDBox";
import MDTypography from "materialDashboard/components/MDTypography";

import Stack from "@mui/material/Stack";
import Card from "@mui/material/Card";
import {useCreateApiKeyMutation} from "../query";


const CardApiKey = ({user}) => {
    const {t} = useTranslation(['user', "validation"]);
    const createApiKeyMutation = useCreateApiKeyMutation();
    const isLoading = createApiKeyMutation.isLoading;
    const createdAPiKey = createApiKeyMutation.data;

    return <Card>
        <MDBox py={2} px={2}>
            <MDTypography variant="h5" fontWeight="medium" textTransform="capitalize">
                {t('cardApiKey.title')}
            </MDTypography>
            {
                isLoading && <MDTypography variant="body2">
                    {t('cardApiKey.loading')}
                </MDTypography>
            }
            {
                !createdAPiKey && !isLoading && (user?.hasApiKey ?
                    <MDTypography variant="body2">
                        {t('cardApiKey.hasApiKey')}
                    </MDTypography>
                    :
                    <MDTypography variant="body2">
                        {t('cardApiKey.noApiKey')}
                    </MDTypography>)
            }
            {
                createdAPiKey && <MDBox>
                    <MDTypography variant="body2" textAlign="center">
                        API KEY:
                    </MDTypography>
                    <MDTypography variant="body2" fontWeight="bold" textAlign="center" sx={{py: 4}}>
                        { createdAPiKey }
                    </MDTypography>
                    <MDTypography variant="body2">
                        {t('cardApiKey.newApiKey')}
                    </MDTypography>
                </MDBox>
            }
            <Stack spacing={2} mt={2} alignItems="center">
                <MDBox>
                    <MDLoadingButton variant="contained"
                                     color="dark"
                                     loading={isLoading}
                                     onClick={createApiKeyMutation.mutateAsync}>
                        {t('cardApiKey.submit')}
                    </MDLoadingButton>
                </MDBox>
            </Stack>
        </MDBox>
    </Card>
}

export default CardApiKey;
